export default __webpack_public_path__ + "static/media/franchise-logo-default-fr.11bf77ad.png";